import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type Severity = 'default' | 'success' | 'error';

interface Feedback {
  message: string,
  action?: string,
  path?: string,
  severity?: Severity,
}

export interface FeedbackState {
  queue: Feedback[],
  message: string,
  open: boolean,
  action: string,
  path: string,
  severity: Severity,
}


const initialState: FeedbackState = {
  queue: [],
  message: '',
  open: false,
  action: '',
  path: '',
  severity: 'success',
}

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    push: (state, action: PayloadAction<Feedback>) => {
      state.queue = [...state.queue, action.payload ];
    },
    next: ( state ) => {

      const { message, action, path, severity } = state.queue[ 0 ];

      state.message = message;
      state.action = action && path ? action : '';
      state.path = action && path ? path : '';
      state.severity = severity ? severity : 'default';

      state.queue = state.queue.slice( 1 );
      state.open = true;
    },
    close: (state) => {
      state.open = false;
    },
  },
})

export const {
  close:closeFeedback,
  push:feedback,
  next:nextFeedback,
} = feedbackSlice.actions

export default feedbackSlice.reducer
